export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/course/createCouponCode',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allCouponCodes'],
       
    })
